import React, { useState } from "react";
import { Typography, Paper, Box, Drawer, Divider } from "@mui/material";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import { useApi } from "../utils/api";

const HomePage = () => {
  const http = useApi();
  const [selectedDate, setSelectedDate] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Örnek etkinlik verisi
  const events = {
    "2025-10-15": [
      { title: "Toplantı", description: "10:00 - 11:00 arası yönetim toplantısı" },
      { title: "Performans Değerlendirme", description: "Çalışan A ile görüşme" },
      { title: "Sınıf Etkinliği", description: "7/A sınıfı" },
    ],
    "2025-10-20": [
      { title: "Müşteri Ziyareti", description: "Müşteri B ile görüşme" },
    ],
  };

  // ✅ Yerel tarih stringi oluştur
  const getLocalDateString = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateClick = (date) => {
    const dateStr = getLocalDateString(date); // UTC değil, local date
    if (events[dateStr]) {
      setSelectedDate(dateStr);
      setDrawerOpen(true);
    }
  };

  return (
    <Box>
      {/* Başlık */}
      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
        Anasayfa
      </Typography>
      <Typography variant="body1" sx={{ color: "gray", mb: 3 }}>
        Tekrar hoş geldiniz! İşte bugün çalışanlarınızla ilgili gelişmeler.
      </Typography>

      {/* Takvim */}
      <Box sx={{ width: "100%", mt: 4 }}>
        <Calendar
          onClickDay={handleDateClick}
          tileContent={({ date, view }) => {
            const dateStr = getLocalDateString(date); // local date
            const dayEvents = events[dateStr];
            if (dayEvents) {
              return (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1, width: "100%" }}>
                  {dayEvents.map((event, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        fontSize: "10px",
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        backgroundColor: idx % 3 === 0
                          ? "rgba(247, 72, 89, 0.15)"  // kırmızı açık
                          : idx % 3 === 1
                            ? "rgba(77, 170, 247, 0.15)" // mavi açık
                            : "rgba(102, 238, 106, 0.15)", // yeşil açık
                        borderLeft: idx % 3 === 0
                          ? "3px solid rgba(247, 72, 89, 0.85)"
                          : idx % 3 === 1
                            ? "3px solid rgba(77, 170, 247, 0.85)"
                            : "3px solid rgba(102, 238, 106, 0.85)",
                        color: "#000",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {event.title}
                    </Box>
                  ))}
                </Box>
              );
            }
            return null;
          }}
          tileClassName={({ date, view }) => {
            const todayStr = getLocalDateString(new Date());
            const dateStr = getLocalDateString(date);
            if (todayStr === dateStr) return "today-tile";
            return null;
          }}
          style={{ width: "100%" }}
        />
      </Box>

      {/* CSS */}
      <style>
        {`
          .react-calendar {
            width: 100% !important;
            border: none;
            font-family: 'Inter', sans-serif;
          }

          .react-calendar__month-view__weekdays {
            text-align: center;
            font-weight: 600;
            margin-bottom: 8px;
          }

          .react-calendar__month-view__days {
            display: grid !important; 
            grid-template-columns: repeat(7, 1fr);
            gap: 3px;
          }

          .react-calendar__tile {
            height: 150px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            border-radius: 2px;
            background-color: #fff;
            border: 1px solid rgba(0,0,0,0.15) !important;
            padding-top: 4px;
            transition: all 0.2s ease-in-out;
            box-sizing: border-box;
            margin: 0; /* Taşmayı önlemek için margin kaldırıldı */
          }

          .react-calendar__tile:hover {
            cursor: pointer;
          }

          .today-tile {
            background-color: #f7f3d2ff !important;
          }

          .react-calendar__tile--active {
            background-color: white !important;
            border: 2px solid blue !important;
            color: black !important;
          }

          .react-calendar__tile span {
            font-size: 12px;
            color: red;
            margin-top: 4px;
          }
        `}
      </style>

      {/* Drawer ile etkinlik detayları */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 350, py: 2, px: 1, display: "flex", flexDirection: "column", height: "100%" }}>

          {/* Başlık ve Kapat Butonu */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Etkinlik Detayı
            </Typography>
            <Box
              sx={{
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: 20,
                lineHeight: 1,
                color: "gray",
              }}
              onClick={() => setDrawerOpen(false)}
            >
              &times;
            </Box>
          </Box>

          {/* Başlığın altındaki çizgi */}
          <Divider sx={{ mb: 2 }} />

          {/* İçerik alanı scrollable */}
          <Box sx={{ overflowY: "auto", flex: 1 }}>
            {selectedDate && events[selectedDate].map((event, idx) => (
              <Paper
                key={idx}
                sx={{
                  p: 1.5,
                  mb: 2,
                  boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
                  borderRadius: 1,
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: idx % 3 === 0
                    ? "rgba(247, 72, 89, 0.15)"  // kırmızı açık
                    : idx % 3 === 1
                      ? "rgba(77, 170, 247, 0.15)" // mavi açık
                      : "rgba(102, 238, 106, 0.15)", // yeşil açık
                  borderLeft: idx % 3 === 0
                    ? "3px solid rgba(247, 72, 89, 0.85)"
                    : idx % 3 === 1
                      ? "3px solid rgba(77, 170, 247, 0.85)"
                      : "3px solid rgba(102, 238, 106, 0.85)",
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {event.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "gray", mt: 0.5 }}>
                  {event.description}
                </Typography>
              </Paper>
            ))}
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default HomePage;
